module.exports = {
    STATUS_ACTIVE: 1,
    STATUS_INACTIVE: 2,
};
